import Snackbar from "jadro-pico-app/Components/UI/Snackbar/Snackbar";
import React from "react";
import styled from "styled-components";
import { ThemeColorEnum } from "../../../../Themes/ThemeEnums";
import { themeColor } from "../../../../Themes/ThemeFunctions";
import { ITheme } from "../../../../Themes/ThemeTypes";
import { useIsMobile } from "../../IsMobileHook";
import { useFab } from "../../../../../../Context/FabContext";
import ExtendedFabButton from "../../../../Button/ExtendedFabButton/ExtendedFabButton";

const Div = styled.div<{ theme: ITheme; $isFullscreen?: boolean; $symmetricMargin?: boolean }>`
  position: relative;
  flex-grow: 1;
  border-radius: ${(props) => (props.$isFullscreen ? "0" : props.theme.base.content.radius)};
  background: ${(props) => themeColor(ThemeColorEnum.SURFACE, props.theme)};
  padding: ${(props) => (props.$isFullscreen ? "0" : props.theme.base.content.padding)};
  margin-left: ${(props) =>
    props.$isFullscreen || !props.$symmetricMargin ? "0" : props.theme.base.content.margin_right};
  margin-right: ${(props) => (props.$isFullscreen ? "0" : props.theme.base.content.margin_right)};
  margin-bottom: ${(props) => (props.$isFullscreen ? "0" : props.theme.base.content.margin_bottom)};

  @media (max-width: ${(props) => props.theme.base.responsive.mobile}px) {
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
    border-radius: 0;
  }
`;

const InnerScroll = styled.div<{ theme: ITheme }>`
  overflow-y: auto;
  height: 100%;
`;

interface AppContentProps {
  children: React.ReactNode;
  isFullscreen?: boolean;
  symmetricMargin?: boolean;
}

const AppContent: React.FC<AppContentProps> = ({
  children,
  isFullscreen = false,
  symmetricMargin = false,
}) => {
  const { fab } = useFab();
  const isMobile = useIsMobile();

  return (
    <Div $isFullscreen={isFullscreen} $symmetricMargin={symmetricMargin}>
      <InnerScroll>
        {children}
        {isMobile && fab && (
          <div onClick={fab.onClick}>
            <ExtendedFabButton icon={fab.icon} label={fab.label} />
          </div>
        )}
      </InnerScroll>
      <Snackbar />
    </Div>
  );
};

export default AppContent;
